export default "__VITE_ASSET__CNg1qKYl__"